<template>
  <h1>Orders</h1>
</template>

<script>
export default {
  name: "Orders",
};
</script>

<style></style>
